import { motion } from "motion/react";
import { Icon } from "../icons";
import { useTranslation } from "../localization";
import { BlankSlate } from "./blank-slate";

export function BlankSlateAIScan() {
	const { t } = useTranslation();

	/** Render */
	return (
		<BlankSlate
			withBorder
			Icon={() => (
				<div className="relative">
					<motion.div
						initial={{ filter: "grayscale(1)" }}
						animate={{
							filter: [
								"grayscale(1)",
								"grayscale(0)",
								"grayscale(0)",
								"grayscale(0)",
								"grayscale(1)",
								"grayscale(1)",
							],
							scale: [1, 1, 0, 0, 1, 1],
						}}
						transition={{
							filter: {
								duration: 2,
								ease: "circInOut",
								times: [0, 0.05, 0.35, 0.55, 0.9, 1],
								repeat: Number.POSITIVE_INFINITY,
								repeatType: "loop",
							},
							scale: {
								duration: 2,
								ease: "circInOut",
								times: [0, 0.35, 0.55, 0.8, 0.9, 1],
								repeat: Number.POSITIVE_INFINITY,
								repeatType: "loop",
							},
						}}
					>
						<Icon
							name="FileText"
							size={36}
							className="stroke-accent-500 fill-accent-500/10"
							strokeWidth={1}
						/>
					</motion.div>
					<motion.div
						className="w-[1px] -inset-y-1 absolute bg-accent-500"
						style={{
							boxShadow: "0px 0px 2px color-mix(in srgb, var(--color-accent-500) 50%, transparent)",
						}}
						initial={{
							left: "-5px",
						}}
						animate={{
							left: "calc(100% + 5px)",
						}}
						transition={{
							repeat: Number.POSITIVE_INFINITY,
							repeatType: "mirror",
							duration: 0.5,
							ease: "circInOut",
							repeatDelay: 0.5,
						}}
					/>
				</div>
			)}
			label={t("misc.scanning_documents")}
		/>
	);
}
